import Vue from 'vue';
import Vuex from 'vuex';
Vue.use(Vuex);

const store = new Vuex.Store({
    state: {
        LOADING: false,
        token: ''
    },
    mutations: {
        showLoading (state) {
            state.LOADING = true;
        },
        hideLoading (state) {
            state.LOADING = false;
        },
        setToken (state, user) {
            state.token = user.token;
        }
    }
});
export default store;



// WEBPACK FOOTER //
// ./src/store/index.js